import React, { PropsWithChildren } from "react";
import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";

const StyledDetails = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone2,
    marginBottom: theme.spacing(3),
}));

const ExpansionPanelDetails = ({ children }: PropsWithChildren) => (
    <StyledDetails variant={"body2"} className="kms-ds-help-page-faq-details">
        {children}
    </StyledDetails>
);

export default ExpansionPanelDetails;
